import { render, staticRenderFns } from "./ViewImmPass.vue?vue&type=template&id=70de3a30&scoped=true&"
import script from "./ViewImmPass.vue?vue&type=script&lang=js&"
export * from "./ViewImmPass.vue?vue&type=script&lang=js&"
import style0 from "./ViewImmPass.vue?vue&type=style&index=0&id=70de3a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de3a30",
  null
  
)

export default component.exports